import type {FallbackProps} from 'react-error-boundary'

import {logError} from '@/utils/logger'

import Error from './ErrorComponent'

export default memo<FallbackProps>(function QueryErrorComponent(props) {
  logError(props.error)

  return <Error reset={props.resetErrorBoundary} />
})
